import transactionPaymentService from "../../../services/http/transactions/transactionPayment.service";
import { transactionPaymentActionTypes } from "../../actionTypes/transactions/transactionPayment.actionTypes";

export const getPaymentPage = (companyId, clientId, chargePointId) => async (dispatch) => {
  let response;
  dispatch({ type: transactionPaymentActionTypes.START_GET_PAYMENT_PAGE });
  try {
    response = await transactionPaymentService.getPaymentPage(companyId, clientId, chargePointId);
    dispatch({ type: transactionPaymentActionTypes.GET_PAYMENT_PAGE_SUCCESS });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: transactionPaymentActionTypes.GET_PAYMENT_PAGE_FAILURE,
      payload: error.message || "Failed to get payment page.",
    });
  }
  return response?.data;
};

export const createPaymentToken = (data) => async (dispatch) => {
  let response;
  dispatch({ type: transactionPaymentActionTypes.START_CREATE_PAYMENT_TOKEN });
  try {
    response = await transactionPaymentService.createPaymentToken(data);
    dispatch({ type: transactionPaymentActionTypes.CREATE_PAYMENT_TOKEN_SUCCESS });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: transactionPaymentActionTypes.CREATE_PAYMENT_TOKEN_FAILURE,
      payload: error.message || "Failed to get payment token.",
    });
  }
  return response?.data;
};

export const getCreditCardsDetails = (companyId, clientId) => async (dispatch) => {
  let response;
  dispatch({ type: transactionPaymentActionTypes.START_GET_CREDIT_CARDS_DETAILS });
  try {
    response = await transactionPaymentService.getCreditCardsDetails(companyId, clientId);
    dispatch({ type: transactionPaymentActionTypes.GET_CREDIT_CARDS_DETAILS_SUCCESS });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: transactionPaymentActionTypes.GET_CREDIT_CARDS_DETAILS_FAILURE,
      payload: error.message || "Failed to get credit cards detials",
    });
  }
  return response?.data;
};

export const deleteClientPaymentToken = (clientPaymentTokenId) => async (dispatch) => {
  let response;
  dispatch({ type: transactionPaymentActionTypes.START_DELETE_PAYMENT_TOKEN });
  try {
    response = await transactionPaymentService.deleteClientPaymentToken(clientPaymentTokenId);
    dispatch({ type: transactionPaymentActionTypes.DELETE_PAYMENT_TOKEN_SUCCESS });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: transactionPaymentActionTypes.DELETE_PAYMENT_TOKEN_FAILURE,
      payload: error.message || "Failed to delete client payment token ",
    });
  }
  return response?.data;
};

export const transactionPaymentActions = {
  getPaymentPage,
  createPaymentToken,
  getCreditCardsDetails,
  deleteClientPaymentToken,
};
